import React from 'react'
import { Row } from 'react-bootstrap'
import {FaGithubAlt, FaLinkedin, FaDribbble, FaMedium} from 'react-icons/fa'

const Footer = () => {
    return (
        <div className = "Footer">
            <Row style={{height: "100%", justifyContent: "center", display: "flex", }}>
                <a href = "https://github.com/Maanaav" target="_blank" style={{padding: "10px", marginTop:"2vh", color: "white", fontSize:"1.3rem"}}><FaGithubAlt></FaGithubAlt></a>
                <a href = "https://www.linkedin.com/in/maanaav-motiramani-795a67189/" target="_blank" style={{padding: "10px", marginTop:"2vh", color: "white", fontSize:"1.3rem"}}><FaLinkedin></FaLinkedin></a>
                <a href = "https://dribbble.com/Maanaav" target="_blank" style={{padding: "10px", marginTop:"2vh", color: "white", fontSize:"1.3rem"}}><FaDribbble></FaDribbble></a>
                <a href = "https://maanaav9.medium.com/" target="_blank" style={{padding: "10px", marginTop:"2vh", color: "white", fontSize:"1.3rem"}}><FaMedium></FaMedium></a>
            </Row>
        </div>
    )
}

export default Footer
